import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7954e05c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-external" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-external-title" }, " 网络共享 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://oss.shumeipan.cn/hezi/images/static/web/samba.png" }),
  /*#__PURE__*/_createElementVNode("span", null, "添加 Samba")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://oss.shumeipan.cn/hezi/images/static/web/webdav.png" }),
  /*#__PURE__*/_createElementVNode("span", null, "添加 WebDAV")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import Page from '@remote/components/layout/SubPage.vue'
import { openAddNetDriveForm } from './helper'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, { title: "添加外部设备" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "add-external-type",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openAddNetDriveForm)({type: 'samba'})))
        }, _hoisted_5),
        _createElementVNode("div", {
          class: "add-external-type",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openAddNetDriveForm)({type: 'webdav'})))
        }, _hoisted_8)
      ])
    ]),
    _: 1
  }))
}
}

})